import entre2actions from '../assets/png/entre2actions.png'
import koolspeed from '../assets/png/koolspeed.png'
import collection100pourcent from '../assets/png/collection100pourcent.png'
import carto from '../assets/png/carto.png'
import junli from '../assets/png/junli.png'
import climatik from '../assets/png/climatik.png'
import klasshair from '../assets/png/klasshair.png'
import unsoutienpourapprendre from '../assets/png/unsoutienpourapprendre.png'
import monicalevert from '../assets/png/monicalevert.png'
import esa from '../assets/png/esa.png'
import dedale from '../assets/png/dedale-dev.png'

export const projectsData = [
    {
        id: 1,
        projectName: 'Librairie ancienne Entre 2 actions',
        projectDesc: 'Application Web / CMS / E-commerce',
        tags: ['Wordpress', 'PHP','HTML' ,'CSS','Javascript','SQL', 'MySQL', 'Apache2','Inkscape'],
        url: 'https://www.livresentre2actions.fr/',
        image: entre2actions
    },
    {
        id: 2,
        projectName: 'Groupe de Pop-rock Reggae Koolspeed',
        projectDesc: 'Site vitrine / CMS / E-commerce',
        tags: ['Wordpress', 'PHP','HTML' ,'CSS','Javascript','SQL', 'MySQL', 'Apache2','Inkscape'],
        url: 'https://www.koolspeed.fr/',
        image: koolspeed
    },
    {
        id: 3,
        projectName: 'Editions Collection 100%',
        projectDesc: 'Application Web / CMS',
        tags: ['Wordpress', 'PHP','HTML' ,'CSS','Javascript','SQL', 'MySQL', 'Apache2','Inkscape'],
        url: 'https://www.collection100pourcent.com/',
        image: collection100pourcent
    },
    {
        id: 4,
        projectName: 'Métadonnées agroclimatiques de l\'INRAE',
        projectDesc: 'Application Web / Cartographie',
        tags: ['JAVASCRIPT','HTML' ,'CSS','JAVA', 'GWT','OPENLAYERS','STRUTS','SPRING', 'HIBERNATE', 'POSTGRESQL', 'APACHE TOMCAT'],
        url: 'https://agroclim.inrae.fr/carto/',
        image: carto
    },
    {
        id: 5,
        projectName: 'Cabinet de massage Bien-être chinois',
        projectDesc: 'Site vitrine / CMS',
        tags: ['Wordpress', 'PHP','HTML' ,'CSS','Javascript','SQL', 'MySQL', 'Apache2','Inkscape'],
        url: 'https://www.junli.fr',
        image: junli
    },
    {
        id: 6,
        projectName: 'Données agroclimatiques de l\'INRA',
        projectDesc: 'Application Web / Gestion de données agroclimatiques',
        tags: ['JAVASCRIPT','HTML' ,'CSS','JAVA', 'GWT','OPENLAYERS','STRUTS','SPRING', 'HIBERNATE', 'POSTGRESQL', 'APACHE TOMCAT'],
        url: 'https://intranet.inrae.fr/climatik/',
        image: climatik
    },
     {
        id: 7,
        projectName: 'Boutique de perruques/rajouts',
        projectDesc: 'Application Web / E-commerce / CMS',
        tags: ['Wordpress', 'PHP','HTML' ,'CSS','Javascript','SQL', 'MySQL', 'Apache2','Inkscape'],
        url: 'https://www.klasshairwigs.com/',
        image: klasshair
    },
     {
        id: 8,
        projectName: 'Site vitrine d\'un cabinet de psychothérapie',
        projectDesc: 'Application Web / CMS',
        tags: ['Wordpress', 'PHP','HTML' ,'CSS','Javascript','SQL', 'MySQL', 'Apache2','Inkscape'],
        url: 'https://www.monicalevert.fr/',
        image: monicalevert
    },
     {
        id: 9,
        projectName: 'Proof of concept d\'une application de gestion de soutien scolaire',
        projectDesc: 'Application Web',
        tags: ['Django', 'Python','HTML' ,'CSS','Javascript','SQL', 'PostgreSQL', 'Nginx','Gunicorn','Inkscape'],
        url: 'https://esa.unsoutienpourapprendre.org/',
        image: esa
    },
     {
        id: 10,
        projectName: 'Site vitrine Dedale, développement & formation IT',
        projectDesc: 'Site vitrine / CMS',
        tags: ['Wordpress', 'PHP','HTML' ,'CSS','Javascript','SQL', 'MySQL', 'Apache2','Inkscape'],
        url: 'https://www.dedale-dev.fr/',
        image: dedale
    },
     {
        id: 11,
        projectName: 'Site vitrine Un soutien pour apprendre, soutien scolaire & numérique',
        projectDesc: 'Site vitrine / CMS',
        tags: ['PHP','HTML' ,'CSS','Javascript','SQL', 'MySQL', 'Apache2','Inkscape'],
        url: 'https://www.unsoutienpourapprendre.org/',
        image: unsoutienpourapprendre
    },
]


// Do not remove any fields.
// Leave it blank instead as shown below

/* 
{
    id: 1,
    projectName: 'Car Pooling System',
    projectDesc: '',
    tags: ['Flutter', 'React'],
    code: '',
    demo: '',
    image: ''
}, 
*/